import { render, staticRenderFns } from "./homeRedesign.vue?vue&type=template&id=60a4a680&scoped=true&"
import script from "./homeRedesign.vue?vue&type=script&lang=js&"
export * from "./homeRedesign.vue?vue&type=script&lang=js&"
import style0 from "./homeRedesign.vue?vue&type=style&index=0&id=60a4a680&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4a680",
  null
  
)

export default component.exports